import http from "../../Services/Auth/config/http-common";
import ICatProveedores from "../../Interfaces/Catalogos/ICatProveedores";
import IRespuesta from "../../Interfaces/Respuestas/IRespuesta";

class CatProveedoresDataService {
  Get() {
    return http.get<ICatProveedores[]>("Catalogos/CatProveedores/Get");
  }
  Append(data: ICatProveedores) {
    return http.post<ICatProveedores>(`Catalogos/CatProveedores/Append`,data);
  }
  Delete(id: number) {
    return http.delete<IRespuesta>(`Catalogos/CatProveedores/Delete/${id}`);
  }
}
export default new CatProveedoresDataService();